module.exports = __webpack_public_path__ + "img/20190919160122284.cecc446a.jpg";